import type { ProjectReportDTO } from "@/application/project-reports/dtos/ProjectReportDTO";
import type { ProjectReportsGatewayPort } from "@/application/project-reports/ports/ProjectReportsGatewayPort";

export class GetProjectReportUseCase {
  constructor(private readonly gateway: ProjectReportsGatewayPort) {}

  async execute(projectId: string, reportId: string): Promise<ProjectReportDTO> {
    if (!projectId || projectId.trim().length === 0) {
      throw new Error("Project ID is required");
    }
    if (!reportId || reportId.trim().length === 0) {
      throw new Error("Report ID is required");
    }

    return this.gateway.getById(projectId, reportId);
  }
}
